import {initData} from "@telegram-apps/sdk";
import {Notify} from "quasar";

export default function () {
    initData.restore()
    const user = initData.user()

    if(user) {
        const echo = useEcho()

        echo
            .private('dialogs.' + user.id)
            .listen('.message.new', (data: any|ApiDialogMessage) => {
                const {$router} = useNuxtApp()

                const currentRoute = $router.currentRoute.value
                if(currentRoute.path !== '/admin/dialogs/' + data.dialogId) {
                    Notify.create('Новое сообщение в диалоге c ' + data.from.name)
                }
            })
    }
}